import React, { useLayoutEffect, useRef } from 'react';
import { hooks } from 'botframework-webchat';
const { useSendMessageBack, useScrollToEnd } = hooks;
import { HYPERLINK_CONTEXT_INTENT_ID_ATTR } from '@sa/bff-contract';
export const openLinkedIntentUrlMiddleware = () => (next) => (...args) => {
    const [{ activity }] = args;
    const render = next(...args);
    if (activity.type === 'message' && render) {
        return (...children) => {
            const wrapperEl = useRef(null);
            const sendMessageBack = useSendMessageBack();
            const scrollToBottom = useScrollToEnd();
            useLayoutEffect(() => {
                var _a;
                (_a = wrapperEl.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[aria-roledescription=message]').forEach((e) => {
                    e.querySelectorAll('a').forEach((anchor) => {
                        var _a, _b;
                        const url = new URL(anchor.href);
                        const intentId = url.searchParams.get('intent');
                        const contextId = (_a = anchor.getAttribute(HYPERLINK_CONTEXT_INTENT_ID_ATTR)) !== null && _a !== void 0 ? _a : '';
                        if (intentId && contextId) {
                            const title = anchor.text;
                            const payload = {
                                type: 'inlineLinkedAnswer',
                                title,
                                intentId,
                                context: {
                                    intentId: contextId,
                                    activityId: activity.id
                                }
                            };
                            const div = document.createElement('div');
                            const handler = (event) => {
                                if (event.type === 'keydown') {
                                    if (event.keyCode === 13 || event.keyCode === 32) {
                                        sendMessageBack(payload, title, title);
                                        event.preventDefault();
                                        scrollToBottom();
                                    }
                                }
                                else if (event.type === 'click') {
                                    sendMessageBack(payload, title, title);
                                    scrollToBottom();
                                }
                            };
                            div.onclick = handler;
                            div.onkeydown = handler;
                            div.setAttribute('role', 'button');
                            div.tabIndex = 0;
                            div.textContent = title;
                            div.className = 'bffButtonLink';
                            div.title = `Ask about ${title}`;
                            (_b = anchor.parentNode) === null || _b === void 0 ? void 0 : _b.replaceChild(div, anchor);
                        }
                    });
                });
            });
            return React.createElement("div", { ref: wrapperEl }, render(...children));
        };
    }
};
//# sourceMappingURL=openLinkedIntentUrlMiddleware.js.map